import chainRpcs from "data/chainRpc"
import moment from "moment"
import { useCallback, useEffect, useState } from "react"
import { getCheckOrder } from "services/commonServices"
import { TOPICS_0, formatNum, getIconUrl } from "utils"
import { getOrderStore, setOrderStore } from "utils/store"
import { createPublicClient, hexToNumber, http } from "viem"

const useOrder = () => {
    const [orderList, setOrderList] = useState([])

    const checkOrderList = useCallback(async (type: string = '') => {
        let tempOrderList = getOrderStore()
        if(type === '') {
            for(let index = 0, length = tempOrderList.length; index < length; index++) {
                let { status, id = '', hash, fromChain, type} = tempOrderList[index]
                if(!id) {
                    try {
                        const { network } = fromChain
                        const rpcUrl = (chainRpcs as any)[network+''].rpcUrl
                        const publicClient = createPublicClient({
                            transport: http(rpcUrl),
                        }) as any;
                        const transaction = await publicClient.getTransactionReceipt({ 
                            hash: hash
                        })
                        if(transaction.status === "success") {
                            const { logs } = transaction
                            logs.forEach((item: any) => {
                                const { topics } = item
                                if(topics[0].toLowerCase() === TOPICS_0.toLowerCase()) {
                                    const idHex = topics[3]
                                    id = hexToNumber(idHex)
                                }
                            });
                            if(type === 'swap') {
                                const confirmations = await publicClient.getTransactionConfirmations({  
                                    transactionReceipt: transaction
                                })
                                if(confirmations > BigInt(3)) {
                                    const originInfo = tempOrderList[index]
                                    originInfo['execHash'] = hash
                                    originInfo['status'] = 'successful'
                                    originInfo['id'] = id
                                    setOrderStore(originInfo)
                                }
                            }
                        }
                        if(transaction.status === "reverted") {
                            const originInfo = tempOrderList[index]
                            originInfo['status'] = 'failed'
                            setOrderStore(originInfo)
                        }
                    } catch(error) {
                        
                    }
                }
                if(status === 'pending' && !!id && type === 'transfer') {
                    await getCheckOrder(id, tempOrderList[index])
                }
            }
        }

        tempOrderList = tempOrderList.map((item: any) => {
            const status = item.status
            if(status === 'pending') {
                item['statusStr'] = 'In Progress'
            } else if(status === 'failed') {
                item['statusStr'] = 'Failed'
            } else {
                item['statusStr'] = 'Successful'
            }
            item['showDate'] = moment(item.createTime).format("DD MMM YY, HH:mm")
            if(item.isBrc20) {
                item['fromTokenImgUrl'] = item.fromToken.imgUrl
                item['toTokenImgUrl'] = item.toToken.imgUrl
            } else {
                item['fromTokenImgUrl'] = getIconUrl(item.fromToken.index, item.fromToken.symbol)
                item['toTokenImgUrl'] = getIconUrl(item.toToken.index, item.toToken.symbol)
            }

            item['fromAmountStr'] = formatNum((parseInt((item.fromAmount * 1000000) + '') / 1000000).toFixed(6))
            item['toAmountStr'] = formatNum((parseInt((item.toAmount * 1000000) + '') / 1000000).toFixed(6))
            return item
        })

        // 根据时间排序
        tempOrderList = tempOrderList.sort((a:any, b: any) => b.createTime - a.createTime)

        setOrderList(tempOrderList)
    }, [])

    useEffect(() => {
        const timer = setInterval(() => {
            checkOrderList()
        }, 1000 * 60 * 1)

        return () => {
            clearInterval(timer)
        }
    }, [checkOrderList])

    useEffect(() => {
        checkOrderList()
    }, [checkOrderList])

    return { orderList, checkOrderList}
}

export default useOrder